import { RadarPage } from "@pages/RadarPage";
import { sidekickModuleEnum } from "@shared/access-control/sidekick-modules";
import { AppRoute } from "./types";

export const radarRoutes: AppRoute[] = [
  {
    path: "/signals",
    element: <RadarPage />,
    protected: true,
    requiredModule: sidekickModuleEnum.RADAR,
  },
];
